module.exports = __webpack_public_path__ + "img/IMG_2586.3fd40cec.jpg";